import { caseInsensitiveStringComparator } from '@utils/utils';

export interface MonthOption {
  label: string;
  value: string;
  selected?: boolean;
}

// Configuration constants
export const VENDOR_REP_CONFIG_CONSTANTS = {
  HEADERS: {
    SELECT: '',
    EMPLOYEE_ID: 'Employee ID',
    NAME: 'Name',
    EMPLOYEE_STATUS: 'Emp. Status',
    EXPERIENCE: 'Exp',
    DNT_LEADER: 'D&T Leader',
    REPORTING_MANAGER: 'Reporting Mgr',
    LOCATION: 'Location',
    WORKING_HRS: 'Working Hrs',
    LEAVES_AVAILED: 'Leaves',
    BILLABLE_HRS: 'Billable',
   
    STATUS: 'Status',
    CALENDAR: 'Calendar'
  },
  FIELDS: {
    SELECT: 'select',
      EMPLOYEE_ID: 'employeeId',
    EMPLOYEE_NAME: 'employeeName',
    EMPLOYEE_STATUS: 'employeeStatus',
    YEARS_OF_EXPERIENCE: 'yearsOfExperience',
    DNT_LEADER: 'l3ManagerName',
    REPORTING_MANAGER: 'reportingManager',
    LOCATION: 'location',
    WORKING_HRS: 'workingHrs',
    BILLABLE_HRS: 'billableHrs',
    LEAVES_AVAILED: 'leavesAvailed',
    STATUS: 'status',
    CALENDAR: 'calendar'
  },
  CELL_TEMPLATES: {
    CUSTOM_SELECT_COLUMN: 'customSelectColumn',
    CUSTOM_STATUS_COLUMN: 'customStatusColumn',
    CUSTOM_EMPLOYEE_STATUS_COLUMN: 'customEmployeeStatusColumn',
  }
} as const;

// Reusable configuration objects
const FILTER_CONFIG = { hideMenu: true };
const SORT_ENABLED_CONFIG = { enabled: true };
const SORT_DISABLED_CONFIG = { enabled: false };
const SORT_WITH_COMPARATOR_CONFIG = { 
  enabled: true,
  comparator: caseInsensitiveStringComparator
};

export const columnDefs = [
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.SELECT,
    dataType: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.SELECT,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.SELECT,
    headerCheckboxSelection: false,
    checkboxSelection: false,
    customCellTemplate: VENDOR_REP_CONFIG_CONSTANTS.CELL_TEMPLATES.CUSTOM_SELECT_COLUMN,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.EMPLOYEE_NAME,
    headerName: 'Employee',
    width: '300px',
    minWidth: '280px',
    filterParams: FILTER_CONFIG,
    sortParams: SORT_WITH_COMPARATOR_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.DNT_LEADER,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.DNT_LEADER,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_WITH_COMPARATOR_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.REPORTING_MANAGER,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.REPORTING_MANAGER,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_WITH_COMPARATOR_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.WORKING_HRS,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.WORKING_HRS,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_ENABLED_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.LEAVES_AVAILED,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.LEAVES_AVAILED,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_ENABLED_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.BILLABLE_HRS,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.BILLABLE_HRS,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_ENABLED_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.STATUS,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.STATUS,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_WITH_COMPARATOR_CONFIG,
    customCellTemplate: VENDOR_REP_CONFIG_CONSTANTS.CELL_TEMPLATES.CUSTOM_STATUS_COLUMN,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.CALENDAR,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.CALENDAR,
    filterParams: FILTER_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.EMPLOYEE_STATUS,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.EMPLOYEE_STATUS,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_WITH_COMPARATOR_CONFIG,
    customCellTemplate: VENDOR_REP_CONFIG_CONSTANTS.CELL_TEMPLATES.CUSTOM_EMPLOYEE_STATUS_COLUMN,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.YEARS_OF_EXPERIENCE,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.EXPERIENCE,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_ENABLED_CONFIG,
  },
  {
    field: VENDOR_REP_CONFIG_CONSTANTS.FIELDS.LOCATION,
    headerName: VENDOR_REP_CONFIG_CONSTANTS.HEADERS.LOCATION,
    filterParams: FILTER_CONFIG,
    sortParams: SORT_WITH_COMPARATOR_CONFIG,
  },
];
export const columnsForExport = [
    { field: 'vendorName',          headerName: 'Vendor' },
    { field: 'employeeId',          headerName: 'Employee ID' },
    { field: 'employeeName',        headerName: 'Name' },
    { field: 'reportingManager',    headerName: 'Reporting Manager' },
    { field: 'workingHrs',          headerName: 'Total Working Hrs' },
    { field: 'leavesAvailed',       headerName: 'Leaves Availed' },
    { field: 'paidLeaves',          headerName: 'Paid Leaves' },
    { field: 'unpaidLeaves',        headerName: 'Unpaid Leaves' },
    { field: 'billableHrs',         headerName: 'Billable Hrs' },
    { field: 'status',              headerName: 'Status' },
    { field: 'l3ManagerName',       headerName: 'L3 Manager' },
    { field: 'l4ManagerName',       headerName: 'L4 Manager' },
    { field: 'l5ManagerName',       headerName: 'L5 Manager' },
    { field: 'location',            headerName: 'Location' },
    { field: 'jobTitle',            headerName: 'Designation' },
    { field: 'lastWorkingDay',      headerName: 'Last Working Day' },
    { field: 'reviewedBy',          headerName: 'Approved By' },
    { field: 'reviewedDate',        headerName: 'Approved Date' },
    { field: 'submittedBy',         headerName: 'Submitted By' },
    { field: 'submittedDate',       headerName: 'Submitted Date' },
  ];